// Client-side data-usage meter. Tracks estimated mobile-data used by media
// (uploads + downloads), per day and per chat. 100% local, no server calls.
const KEY = "rc_data_usage";
const todayKey = () => new Date().toISOString().slice(0, 10);

function read() {
  try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; }
}
function write(d) { try { localStorage.setItem(KEY, JSON.stringify(d)); } catch {} }

function record(bytes, dir, chatId) {
  if (!bytes || bytes < 0) return;
  const d = read();
  d.days = d.days || {}; d.chats = d.chats || {}; d.total = d.total || { sent: 0, recv: 0 };
  const dk = todayKey();
  d.days[dk] = d.days[dk] || { sent: 0, recv: 0 };
  d.days[dk][dir] = (d.days[dk][dir] || 0) + bytes;
  d.total[dir] = (d.total[dir] || 0) + bytes;
  if (chatId) {
    d.chats[chatId] = d.chats[chatId] || { sent: 0, recv: 0 };
    d.chats[chatId][dir] = (d.chats[chatId][dir] || 0) + bytes;
  }
  const cutoff = new Date(Date.now() - 31 * 864e5).toISOString().slice(0, 10);
  for (const k of Object.keys(d.days)) if (k < cutoff) delete d.days[k];
  write(d);
  try { window.dispatchEvent(new Event("rc-data-usage")); } catch {}
}

export const recordSent = (bytes, chatId) => record(bytes, "sent", chatId);
export const recordRecv = (bytes, chatId) => record(bytes, "recv", chatId);

export function getUsage() {
  const d = read();
  const days = d.days || {}; const chats = d.chats || {}; const total = d.total || { sent: 0, recv: 0 };
  const today = days[todayKey()] || { sent: 0, recv: 0 };
  const week = { sent: 0, recv: 0 };
  for (let i = 0; i < 7; i++) {
    const k = new Date(Date.now() - i * 864e5).toISOString().slice(0, 10);
    const v = days[k]; if (v) { week.sent += v.sent || 0; week.recv += v.recv || 0; }
  }
  const series = [];
  for (let i = 13; i >= 0; i--) {
    const k = new Date(Date.now() - i * 864e5).toISOString().slice(0, 10);
    const v = days[k] || { sent: 0, recv: 0 };
    series.push({ day: k.slice(5), bytes: (v.sent || 0) + (v.recv || 0) });
  }
  return { today, week, total, series, chats };
}

export function resetUsage() {
  write({});
  try { window.dispatchEvent(new Event("rc-data-usage")); } catch {}
}

export function fmtBytes(b) {
  if (!b) return "0 B";
  const u = ["B", "KB", "MB", "GB"];
  const i = Math.min(u.length - 1, Math.floor(Math.log(b) / Math.log(1024)));
  return `${(b / 1024 ** i).toFixed(i ? 1 : 0)} ${u[i]}`;
}
